import { createFileRoute } from "@tanstack/react-router";
import { AccordionExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/radix/accordion")({
  component: AccordionExamples,
});
